var _metadata, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5716\\u5C64_1",
    style: {
      height: "100%",
      width: "100%",
      background: "rgb(255, 255, 255)",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(-0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.833333s infinite normal forwards running breath-d14e9c6e-b695-4e40-8ee0-b33cccde9449"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M74.31 71.184c-4.942 0-9.097-3.435-10.203-8.043a3.588 3.588 0 0 1-.391.022H35.584c-.098 0-.196-.004-.292-.012-1.109 4.603-5.261 8.033-10.2 8.033-4.977 0-9.156-3.484-10.225-8.141a3.543 3.543 0 0 1-.852-.042c-5.16-.885-8.949-5.317-9.009-10.537L5 51.913c-.065-5.73 3.468-10.834 8.044-11.621 1.874-.322 5.626-2.532 7.844-5.006 3.278-3.657 9.523-6.424 14.526-6.436l14.395-.034c5.018 0 11.316 2.767 14.681 6.437l.197.215c2.169 2.365 6.835 4.961 9.985 5.558l10.116 1.913c5.516 1.043 9.997 5.699 10.204 10.601.096 2.302-.754 4.533-2.394 6.281-1.922 2.05-4.773 3.265-7.82 3.332l-.08.001c-.064 0-.126-.002-.189-.005-1.108 4.605-5.261 8.035-10.199 8.035z",
    style: {
      fill: "rgb(209, 209, 209)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.11111s infinite normal forwards running breath-d14e9c6e-b695-4e40-8ee0-b33cccde9449"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M24.742 53.746a6.947 6.947 0 1 1 0 13.894 6.947 6.947 0 1 1 0-13.894zm49.217 0a6.947 6.947 0 1 1 0 13.894 6.947 6.947 0 0 1-6.947-6.947 6.946 6.946 0 0 1 6.947-6.947zm9.821-7.327l-10.117-1.913c-3.89-.736-9.261-3.725-11.937-6.643l-.199-.216c-2.675-2.918-8.102-5.298-12.061-5.289l-14.395.034c-3.959.009-9.312 2.375-11.896 5.258s-7.031 5.643-9.882 6.133c-2.851.49-5.147 4.13-5.102 8.089l.006.552c.04 3.544 2.673 6.503 6.065 7.086.591-5.26 5.064-9.362 10.478-9.362 5.453 0 9.952 4.159 10.492 9.472h28.132c.54-5.312 5.04-9.472 10.492-9.472 5.449 0 9.947 4.156 10.49 9.465 3.864-.086 6.887-2.715 6.754-5.924-.135-3.263-3.429-6.534-7.32-7.27zm-54.621-1.376c-3.959-.015-5.698-1.991-3.865-4.392 1.832-2.4 6.571-4.365 10.529-4.365h3.967l2.534 8.806-13.165-.049zm27.77.102l-10.856-.04-2.539-8.819h5.483c3.959 0 8.978 1.999 11.153 4.443 2.177 2.443.718 4.43-3.241 4.416z",
    style: {
      fill: "rgb(69, 69, 69)"
    }
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    xmlnsD: "https://loading.io/stock/"
  }, /*#__PURE__*/React.createElement("dName", null, "car"), /*#__PURE__*/React.createElement("dTags", null, "drive,automobile,wheel,move,car,map"), /*#__PURE__*/React.createElement("dLicense", null, "by"), /*#__PURE__*/React.createElement("dSlug", null, "8h4nk3"))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "breath-d14e9c6e-b695-4e40-8ee0-b33cccde9449",
    "data-anikit": ""
  }, "@keyframes breath-d14e9c6e-b695-4e40-8ee0-b33cccde9449\r\n{\r\n  0% {\r\n    animation-timing-function: cubic-bezier(0.9647,0.2413,-0.0705,0.7911);\r\n    transform: scale(0.9099999999999999);\r\n  }\r\n  51% {\r\n    animation-timing-function: cubic-bezier(0.9226,0.2631,-0.0308,0.7628);\r\n    transform: scale(1.02994);\r\n  }\r\n  100% {\r\n    transform: scale(0.9099999999999999);\r\n  }\r\n}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCar);
export default __webpack_public_path__ + "static/media/loading-car.9f574878eaedd9f3a0974484d2923b38.svg";
export { ForwardRef as ReactComponent };